import { fuseFilter, nullOrUndefined } from '@/plugins/fuse'
import { SSharedList } from '@/services/shared'
import QUERY from 'lodash'

export default {
  data () {
    return {
      fetching: {
        regions: false
      },
      options: {
        regions: []
      },
      selected: {
        region: ''
      },
      editable: {
        region: ''
      }
    }
  },

  methods: {

    async getRegions (context, search = '') {
      const selectedContext = context?.selected
      const fetchingContext = context?.fetching
      const optionsContext = context?.options

      if (nullOrUndefined(selectedContext) || nullOrUndefined(fetchingContext) || nullOrUndefined(optionsContext)) {
        throw Error('Invalid context object')
      }

      const selected = context.selected?.region
      const fetching = context.fetching?.regions
      const options = context.options?.regions

      if (nullOrUndefined(selected) || nullOrUndefined(fetching) || nullOrUndefined(options)) {
        throw Error('Invalid context object')
      }

      context.fetching.regions = true
      context.selected.region = ''

      const filters = {
        filter_text: search
      }

      return await SSharedList.getRegions(filters).then(
        ({ data }) => {
          context.options.regions = data
        }
      ).catch(() => {
        context.options.regions = []
      }).finally(() => {
        context.fetching.regions = false
      })
    },

    async searchRegions (search, loading) {
      this.searchRegionsProvider(this, search, loading)
    },

    searchRegionsProvider: QUERY.debounce(
      ({ options }, search, loading) => {
        const filteredOptions = fuseFilter(search, options.regions, {
          keys: ['region_name']
        })

        if (filteredOptions.length < 1) {
          loading(true)

          const filters = {
            filter_text: search
          }

          SSharedList.getRegions(filters).then(
            ({ data }) => {
              options.regions = data
            }
          ).catch(() => {
            options.regions = []
          }).finally(() => {
            loading(false)
          })
        }
      }, 500
    )
  }
}
